export const ANALYTICS_DETAILS_DATA = [
  'cost_centers',
  'sites',
  'users',
] as const;

export const USER_ANALYTICS_DETAILS_SORT_BY = [
  'company_name',
  'email',
  'first_name',
  'is_active',
  'last_active_datetime',
  'last_name',
  'mobile_app_version',
  'signed_delivery_notes_count',
] as const;
